import React, { useState } from 'react';
import {
  Box, Button, Container, Paper, TextField, Typography, Link, Alert, Stack
} from '@mui/material';
import LockResetIcon from '@mui/icons-material/LockReset';
import { useMutation } from '@apollo/client';
import { Link as RouterLink } from 'react-router-dom';
import { FORGOT_PASSWORD_MUTATION } from '../graphql/queries';

export default function ForgotPasswordPage() {
  const [identifier, setIdentifier] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const [forgotPassword, { loading }] = useMutation(FORGOT_PASSWORD_MUTATION);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await forgotPassword({ variables: { identifier: identifier.trim() } });
      setSent(true);
    } catch (err) {
      setError(err.message || 'Could not send the reset email. Please try again.');
    }
  };

  return (
    <Box sx={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #4a0072 0%, #ae52d4 100%)',
      display: 'flex',
      alignItems: 'center',
    }}>
      <Container maxWidth="xs">
        <Paper elevation={6} sx={{ p: 5, borderRadius: 4 }}>
          <Stack alignItems="center" spacing={1} mb={4}>
            <LockResetIcon sx={{ fontSize: 36, color: 'primary.main' }} />
            <Typography variant="h5" fontWeight={700}>Forgot Password</Typography>
            <Typography variant="body2" color="text.secondary" align="center">
              Enter your email address or user ID and we'll email you a link to reset your password
            </Typography>
          </Stack>

          {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}

          {sent ? (
            <Alert severity="success" sx={{ mb: 2 }}>
              If an account matches what you entered, a password reset link has been sent to its email address.
              The link expires in 1 hour.
            </Alert>
          ) : (
            <form onSubmit={handleSubmit}>
              <TextField
                label="Email Address or User ID"
                name="identifier"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                fullWidth
                required
                autoFocus
                sx={{ mb: 4 }}
              />
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                size="large"
                disabled={loading}
                sx={{ fontWeight: 700, py: 1.5 }}
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </Button>
            </form>
          )}

          <Typography variant="body2" align="center" sx={{ mt: 3 }}>
            <Link component={RouterLink} to="/login" fontWeight={600}>
              Back to Sign In
            </Link>
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}
